import api from '@/security/api'
import errorCatch from '@/helpers/errorCatch'
import querystring from 'querystring'

require('./../../security/interceptors')

const all = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/blacklist?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar os contatos')
        })
}

const update = (data) => {
    return api.put('/blacklist', data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível atualizar a blacklist.')
        })
}

const single = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/blacklist/single?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível cadastrar a blacklist.')
        })
}

const multiple = (data) => {
    let formData = new FormData()

    formData.append('file', data.file)
    formData.append('optional', data.optional)

    return api.post('/blacklist/multiple', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível cadastrar a blacklist.')
        })
}

export default {
    all,
    update,
    single,
    multiple
}
